/**
 * O seletor de qual lista a tela mostra.
 *
 * O modulo 01 tem seis cadastros de estrutura e tres vistas de governanca; o 08
 * tem tanque, posto e produto. Uma entrada de menu para cada afogaria o mapa da
 * solucao — e nenhuma delas e um modulo: sao listas do mesmo assunto, com a
 * mesma tabela, o mesmo formulario e a mesma trilha.
 *
 * Ele morava em `modulos/cadastros/` e veio para ca quando ganhou o segundo
 * consumidor. Nao ha nada do modulo 01 nele: e um grupo de botoes que lembra
 * qual esta ligado.
 *
 * O ESTADO VAI PARA A URL, como todo filtro (p.16): `?tipo=obras` e um link que
 * se manda para alguem.
 *
 * E o SELETOR SEGMENTADO da v2.1 (p.23): troca de visao, de 2 a 4 itens, num
 * trilho cinza em que o escolhido vira superficie branca — o mesmo desenho das
 * abas de modulo, porque e o mesmo gesto de "trocar o que se ve". Com mais
 * itens do que o trilho comporta, ele rola de lado, so ele.
 *
 * Nao e uma acao primaria: escolher a lista e navegacao, nao a acao que a tela
 * existe para provocar. Por isso nenhum deles e laranja preenchido — laranja
 * cheio ha um so por tela, e ele e o "Cadastrar".
 */
export function Seletor<T extends string>({
  rotulo,
  valor,
  opcoes,
  aoEscolher,
  larguraCheia = false,
}: {
  /** Nome acessivel do grupo: "Cadastro", "Vista". */
  readonly rotulo: string;
  readonly valor: T;
  readonly opcoes: readonly { readonly valor: T; readonly rotulo: string }[];
  readonly aoEscolher: (valor: T) => void;
  /** Dentro de formulario: ocupa a linha e quebra em vez de rolar, para nenhuma opcao ficar escondida. */
  readonly larguraCheia?: boolean;
}) {
  return (
    <div role="group" aria-label={rotulo} className="trilho-de-abas" {...(larguraCheia ? { 'data-largura': 'cheia' } : {})}>
      {opcoes.map((opcao) => {
        const escolhida = opcao.valor === valor;
        return (
          <button
            key={opcao.valor}
            type="button"
            aria-pressed={escolhida}
            className="aba-modulo"
            onClick={() => {
              aoEscolher(opcao.valor);
            }}
          >
            {opcao.rotulo}
          </button>
        );
      })}
    </div>
  );
}
